import React from 'react';
import AppErrorBanner from '@/ui/components/AppErrorBanner';

type Props = {
  message: string | unknown;
  onDismiss?: () => void;
};

/** @deprecated Import AppErrorBanner from `ui` — kept for backward compatibility */
export default function ErrorBanner(props: Props) {
  return <AppErrorBanner {...props} />;
}

export { AppErrorBanner };
